/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LpInspectionDto } from '../../models/lp-inspection-dto';

export interface LpInspectionControllerRestore$Params {
  id: string;
}

export function lpInspectionControllerRestore(http: HttpClient, rootUrl: string, params: LpInspectionControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<LpInspectionDto>> {
  const rb = new RequestBuilder(rootUrl, lpInspectionControllerRestore.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LpInspectionDto>;
    })
  );
}

lpInspectionControllerRestore.PATH = '/api/lp-inspection/{id}/restore';
